import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDashboardInsight,
  fetchTopProducts,
} from "../../services/api";

export const fetchDashboardInsgihtThunk = createAsyncThunk(
  "_dashboard/fetchDashboardInsgihtThunk",
  async (range: number) => {
    try {
      const response = await fetchDashboardInsight(range);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
);

export const fetchTopProductsThunk = createAsyncThunk(
  "_dashboard/fetchTopProductsThunk",
  async () => {
    try {
      const response = await fetchTopProducts();
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
);
